import { useEffect } from "react";

export const SITE_URL = "https://inspectorproleads.com";

const DEFAULTS = {
  title: document.title,
  description: document.head.querySelector('meta[name="description"]')?.getAttribute("content") || "",
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export const useSeo = ({ title, description, path, jsonLd, type = "website" }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("name", "twitter:card", "summary_large_image");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.seo = "page";
    script.text = JSON.stringify(jsonLd || {});
    document.head.appendChild(script);
    return () => {
      script.remove();
      document.title = DEFAULTS.title;
      setMeta("name", "description", DEFAULTS.description);
      ["og:title", "og:description", "og:url", "og:type"].forEach((k) => document.head.querySelector(`meta[property="${k}"]`)?.remove());
      document.head.querySelector('link[rel="canonical"]')?.remove();
    };
  }, [title, description, path, jsonLd, type]);
};
